module.exports = __webpack_public_path__ + "static/7-8fc0268e78029bf078ecff3d1d843b0c.jpeg";